import React from 'react'
import ToolTipBase from './../../../components/ToolTip';

export default ({ className, show, ...props }) => <ToolTipBase className={`zt-event-buy__aside__group-seats__seat__tooltip ${show?'zt-event-buy__aside__group-seats__seat__tooltip--show' :''}`} {...props}>
    <div className='zt-event-buy__tooltip__header zt-p3'>Because of group you can remove seats only from the edges.</div>
</ToolTipBase>;